export default __webpack_public_path__ + "static/daliaTalk-e97219a67f0c4e3cc7b223d985ef303b.jpg";